module.exports = __webpack_public_path__ + "static/media/map-pin-brand.9d57dbde.svg";